import { useState, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Button from '@material-ui/core/Button';
import Link from 'next/link';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { useMount, useCountDown, useUpdateEffect } from 'ahooks';
import { getTokenExpireDate } from '../../../utils/feathers';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    // minWidth: 300,
    transform: 'translateZ(0)',
    // The position fixed scoping doesn't work in IE 11.
    // Disable this demo to preserve the others.
    '@media all and (-ms-high-contrast: none)': {
      display: 'none',
    },
  },
  open: {
    position: 'absolute',
    left: 0,
    right: 0,
    zIndex: 10000,
    height: '100vh',
  },
  modal: {
    display: 'flex',
    padding: theme.spacing(1),
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    width: 400,
    backgroundColor: theme.palette.background.paper,
    border: `2px solid ${theme.palette.primary.main}`,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
  linkLogin: {
    textAlign: 'center',
  },
}));

const LogoutModal = () => {
  const classes = useStyles();
  const rootRef = useRef(null);
  const { t } = useTranslation();
  const [countdown, setTargetDate] = useCountDown();

  const [open, setOpen] = useState(false);
  const [hide, setHide] = useState(false);

  useMount(() => {
    const targetDate = getTokenExpireDate();
    if (targetDate) {
      setTargetDate(targetDate);
    } else {
      setHide(true);
    }
  });

  useUpdateEffect(() => {
    if (open === false && (countdown / 1000) <= 0) {
      setOpen(true);
    }
  }, [countdown]);

  if (hide) {
    return (<div />);
  }

  return (
    <div className={clsx(classes.root, open ? classes.open : null)} ref={rootRef}>
      <Modal
        disablePortal
        disableEnforceFocus
        disableAutoFocus
        open={open}
        className={classes.modal}
        container={() => rootRef.current}
      >
        <div className={classes.paper}>
          <h2>{t('web/logoutmodal.text.title')}</h2>
          <div className={classes.linkLogin}>
            <Link href="/logout">
              <Button variant="contained" color="primary">
                {t('web/logoutmodal.button.login')}
              </Button>
            </Link>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default LogoutModal;
